<template>
    <div>
        <div class="mt-3">
            {{ translate("Write max.") }} {{ recommended_length }}
            {{ translate("words") }}
        </div>
        <small v-if="word_count" class="text-dark"
            >{{ translate("Word count") }}: {{ word_count }}</small
        >
    </div>
</template>

<script>
export default {
    props: ["word_count", "recommended_length"],
};
</script>
